import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from "react";
import "./MultipleIps.css";
import { v4 as v4Re, v6 as v6Re } from "cidr-regex";
import Alert from "../Alerts/Alerts";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  languageChange,
  currentSelectedLanguage,
  updateSettingsData,
  validateInput,
} from "../../../StateManagement/actions";
import { updateFormData } from "../../../StateManagement/formChanges-slice";

const tabMap = {
  Personal: "personalTab",
  Company: "companyTab",
  Admin: "AdminTab",
};
// export default function MultipleIps(props, ref) {
const MultipleIps = forwardRef((props, ref) => {
  const location = useLocation();
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const outerTabSelected = useSelector(state => state.settings.settingFor);
  // const settings=useSelector(state => state.settings);
  // const tabKey = tabMap[outerTabSelected === "User" ? "Personal" : outerTabSelected];
  // const isDirectSend=settings[tabKey]?.selectedTab === selectedLanguage.LstLanguageCodes.UI_DirectSendDefaults;
  const dispatch = useDispatch();
  function removeIp(ipsList, ip, id) {
    setConsMultipleIps((consMultipleIps) =>
      consMultipleIps.filter((ips) => ips !== ip)
    );
    // if(isDirectSend){
    const filteredIps = consMultipleIps.filter((ips) => ips !== ip);
    dispatch(updateSettingsData({
      type: props.id,
      value: (filteredIps.length > 0) ? "{" + [...filteredIps] + "}" : "",
      level: props.level,
      outerTabSelected: outerTabSelected === "User" ? 'Personal' : outerTabSelected,
    }))
    if (location.pathname === "/send" || location.pathname === "/create") {
      dispatch(updateFormData({ type: 'AllowedIP', value: [...filteredIps].join(",") }))
    }
    // }
    var Ipcontrols = document.getElementById(props.id);

    if (props.Prevdata && props.Prevdata.length > 0) {
      props.Prevdata.forEach((e1) => {
        if (e1 === ip) {
          Ipcontrols.setAttribute("is-datachanged", "true");
        } else {
          Ipcontrols.setAttribute("is-datachanged", "false");
        }
      });
    } else {
      Ipcontrols.setAttribute("is-datachanged", "true");
    }
  }
  var letmultipleipsCheck = false;

  var letmultipleips = [];
  if (props.constmultipleips.length > 0 && props.constmultipleips[0] != "") {
    letmultipleips = props.constmultipleips;
    letmultipleipsCheck = true;

  }
  const [consMultipleIps, setConsMultipleIps] = useState(letmultipleips);
  const [consSelect, setConsSelect] = useState(props.display == "none" ? true : (letmultipleipsCheck ? true : false));
  const [consMultipleIp, setConsMultipleIp] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [timer, setTimer] = useState("");
  const [position, setPosition] = useState(null);
  const handleMouseEnter = (e) => {
    const box = e.target.getBoundingClientRect();
    const { top, bottom, left, right } = box;
    const centerX = left + (right - left) / 2;
    const centerY = top + (bottom - top) / 2;
    const newPosition = centerY < window.innerHeight / 2 ? 'bottom' : 'top';
    setPosition(newPosition);
  };
  useImperativeHandle(ref, () => ({
    setArrayIpList(ipLists) {
      let formattedIps = ipLists;
      if (Array.isArray(ipLists)) {
        formattedIps = ipLists.map(ip => {
          if (ip.startsWith('{') && ip.endsWith('}')) {
            return ip.replace(/[{}]/g, '');
          }
          return ip;
        });
      }
      letmultipleips = formattedIps;
      setConsMultipleIps(formattedIps);
      setConsSelect(true);
      if ((location.pathname === "/send" || location.pathname === "/create") && formattedIps.length > 0) {
        dispatch(updateFormData({ type: 'IpCheck', value: true }))
      }
    },
    setUserArrayIpList(ipLists) {
      letmultipleips = ipLists;
      setConsMultipleIps(letmultipleips);
      setConsSelect(true);
      if ((location.pathname === "/send" || location.pathname === "/create") && ipLists.length > 0) {
        dispatch(updateFormData({ type: 'IpCheck', value: true }))
      }
    },
    ClearControls() {
      setConsMultipleIps("");
    }
  }));
  // useEffect(() => {
  //   clearTimeout(timer);
  //   setTimer(
  //     setTimeout(() => {
  //       setAlertMsg("");
  //       setAlertType("");
  //     }, 5000)
  //   );
  // }, [alertType]);

  function handlerKeyPress(event) {
    //console.log("handlerKeyPress " + event.keyCode);
  }
  function handleKeyDown(event) {
    //console.log("handlerKeyDown " + event.type);
    localStorage.setItem("Ipchange", "true");
    if ((event.keyCode === 13 || event.type == "blur") && event.target.value != "") {
      const re4 = v4Re({ exact: true });
      var Ipcontrols = document.getElementById(props.id);
      Ipcontrols.setAttribute("isWarning", false);
      const re6 = v6Re({ exact: true });
      const str = event.target.value;
      const isCidr = re4.test(str) ? 4 : re6.test(str) ? 6 : 0;
      var ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if (
        (isCidr === 0 && event.target.value.match(ipformat)) ||
        isCidr === 4 ||
        isCidr === 6
      ) {
        if (consMultipleIps.length === 0 || consMultipleIps.filter((ips) => ips === consMultipleIp).length === 0) {
          setConsMultipleIps((consMultipleIps) => [
            ...consMultipleIps,
            consMultipleIp,
          ]);

          dispatch(updateSettingsData({
            type: props.id,
            value: "{" + [...consMultipleIps, consMultipleIp] + "}",
            level: props.level,
            outerTabSelected: outerTabSelected === "User" ? 'Personal' : outerTabSelected,
          }))
          if (location.pathname === "/send" || location.pathname === "/create") {
            dispatch(updateFormData({ type: 'AllowedIP', value: [...consMultipleIps, consMultipleIp].join(",") }))
          }
          setConsMultipleIp("");
        } else {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_YouhaveEnteredAnAlreadyEnteredIpAdress + "!");
          setConsMultipleIp("");
          setAlertType("warning");
          Ipcontrols.setAttribute("isWarning", true);
          Ipcontrols.setAttribute("is-datachanged", "false");
          return;
        }
      } else {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_YouhaveenteredanInvalidIP);
        setConsMultipleIp("");
        setAlertType("warning");
        Ipcontrols.setAttribute("isWarning", true);
        Ipcontrols.setAttribute("is-datachanged", "false");
        dispatch(validateInput({ value: true }))
        return false;
      }
    }
  }
  function handleKeyUp(event) {
    //console.log("handlerKeyUp " + event.keyCode);
  }
  function multipleIpchange(event) {
    setConsMultipleIp(event);
    var Ipcontrols = document.getElementById(props.id);
    Ipcontrols.setAttribute("is-datachanged", "true");
  }

  return (
    <>
      {/* alerts */}
      <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg} setAlertType={setAlertType} className="alerthist-ip"></Alert>
      {/* end */}
      <div className="row">
        <div className="col-sm-12 res-pr2 pl-6p settings">
          <div className="input-group field mt-3 res-mt50 res-column custom-inputBorder">
            {props.isfromSetting != "true" && (
              <div
                className="checkbox control usercheck"
                style={{ padding: "0.29rem 0.8rem" }}
              >

                <label style={{
                  color: '#4b5d68 !important',
                  fontWeight: '500 !important'
                }}
                  className={`ip-address mb-0 toolltipModified ${position}`}
                  data-bs-toggle="tooltip"
                  data-placement="top"
                  onMouseEnter={handleMouseEnter}
                >
                  {props.display != "none" && (
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="restrictIP"
                      value={consSelect}
                      checked={consSelect}
                      onChange={(e) => {
                        setConsSelect(e.target.checked)
                        if (location.pathname === "/send" || location.pathname === "/create") {
                          dispatch(updateFormData({ type: 'IpCheck', value: e.target.checked }))
                        }
                      }}

                    />
                  )
                  }
                  {props.display != "none" && (
                    <span className="cr">
                      <i className="cr-icon material-icons">check</i>
                    </span>
                  )
                  }
                  {props.display == "none" && (selectedLanguage.LstLanguageCodes.UI_AllowedIP)}
                  {props.display != "none" && (selectedLanguage.LstLanguageCodes.UI_ByIP)}
                  <span className="ModToollTips">{selectedLanguage.LstLanguageCodes.UI_RestrictsAccesstoArange}</span>
                </label>
              </div>

            )}
            <input
              id={props.id}
              type={props.type}
              onKeyPress={(e) => handlerKeyPress(e)}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
                handleKeyDown(e);
              }}
              onKeyUp={(e) => handleKeyUp(e)}
              onChange={(e) => multipleIpchange(e.target.value)}
              onBlur={(e) => handleKeyDown(e)}
              placeholder={selectedLanguage.LstLanguageCodes.UI_EntereachAuthorizedIP}
              title={selectedLanguage.LstLanguageCodes.UI_EntereachAuthorizedIP}
              className="form-control byip-input border-Left"
              constmultipleips={consMultipleIps}
              value={consMultipleIp}
              disabled={props.disabled == true ? true : !consSelect}
              is-datachanged="false"
            ></input>
          </div>
        </div>
      </div>
      {typeof consMultipleIps !== "string" && consMultipleIps.length > 0 && (
        <div className={props.display != "none" ? "w-100 red-shadow react-multi-ip " : "w-100 red-shadow react-multi-ip history-ips"}>
          {consMultipleIps.length > 0 &&
            consMultipleIps.map((ips, index) => (
              <div
                key={index}
                className="d-flex align-items-center"
                data-tag="true"
                id={"labelIp" + index}
              >
                <label style={{ marginBottom: 0.1 }}>{ips}</label>
                {
                  props.disabled != true ? <span
                    data-tag-handle="true"
                    className="material-icons text-danger top-2 ms-2"
                    onClick={() => removeIp(consMultipleIps, ips, index)}
                  >
                    clear
                  </span> : ""
                }
              </div>
            ))}
        </div>
      )}
    </>
  );
})
export default MultipleIps;